export type KelompokAuditLimbahTajam = "A" | "B" | "C";

export type PenilaianAuditLimbahTajam = "ya" | "tidak" | "na";

export type KategoriAuditLimbahTajam = "sangat_baik" | "baik" | "cukup_kurang";

export interface KriteriaAuditLimbahTajam {
  no: number;
  no_label: string;
  kelompok: KelompokAuditLimbahTajam;
  kriteria: string;
  dasar_regulasi: string;
}

export const AUDIT_LIMBAH_TAJAM_PRIVILEGE = "audit_limbah_tajam";

export const KELOMPOK_AUDIT_LIMBAH_TAJAM: Record<KelompokAuditLimbahTajam, string> = {
  A: "Fasilitas & Wadah Limbah Tajam (Safety Box)",
  B: "Praktek Penanganan Limbah Tajam (Petugas)",
  C: "Pengangkutan & Penyimpanan Sementara"
};

export const KRITERIA_AUDIT_LIMBAH_TAJAM: KriteriaAuditLimbahTajam[] = [
  {
    no: 1,
    no_label: "1",
    kelompok: "A",
    kriteria: "Safety box tersedia di area lokasi tindakan/perawatan.",
    dasar_regulasi: "Permenkes 27/2017 (PPI — pengelolaan benda tajam)"
  },
  {
    no: 2,
    no_label: "2",
    kelompok: "A",
    kriteria:
      "Safety box yang digunakan bersifat anti bocor, anti tusuk, dan memiliki penutup.",
    dasar_regulasi: "Permenkes 27/2017 (PPI); Permenkes 7/2019 (Kesling RS)"
  },
  {
    no: 3,
    no_label: "3",
    kelompok: "A",
    kriteria:
      "Safety box terpasang dengan aman (diletakkan pada tiang troli tindakan / bracket dinding / area yang terjangkau).",
    dasar_regulasi: "Permenkes 27/2017 (PPI — pengelolaan benda tajam)"
  },
  {
    no: 4,
    no_label: "4",
    kelompok: "A",
    kriteria:
      "Volume isi safety box TIDAK melebihi ¾ bagian (belum penuh/melimpah).",
    dasar_regulasi: "Permenkes 27/2017 (PPI — pengelolaan benda tajam)"
  },
  {
    no: 5,
    no_label: "5",
    kelompok: "B",
    kriteria:
      "Petugas segera membuang limbah tajam/jarum langsung setelah digunakan (point of use).",
    dasar_regulasi: "Permenkes 27/2017 (PPI — penyuntikan aman)"
  },
  {
    no: 6,
    no_label: "6",
    kelompok: "B",
    kriteria:
      "Petugas TIDAK melakukan recapping (menutup kembali jarum bekas pakai) dengan dua tangan. (Jika harus recapping, wajib menggunakan teknik satu tangan / one-handed scoop technique).",
    dasar_regulasi: "Permenkes 27/2017 (PPI — penyuntikan aman)"
  },
  {
    no: 7,
    no_label: "7",
    kelompok: "B",
    kriteria:
      "Petugas TIDAK mematahkan, membengkokkan, atau melepas jarum dari spuit secara manual menggunakan tangan.",
    dasar_regulasi: "Permenkes 27/2017 (PPI — penyuntikan aman)"
  },
  {
    no: 8,
    no_label: "8",
    kelompok: "B",
    kriteria:
      "Benda tajam dimasukkan utuh (spuit + jarum) langsung ke dalam safety box.",
    dasar_regulasi: "Permenkes 27/2017 (PPI — pengelolaan benda tajam)"
  },
  {
    no: 9,
    no_label: "9",
    kelompok: "C",
    kriteria:
      "Safety box ditutup/dikunci dengan aman ketika sudah terisi ¾ bagian sebelum dipindahkan.",
    dasar_regulasi: "Permenkes 27/2017 (PPI); Permenkes 7/2019 (Kesling RS)"
  },
  {
    no: 10,
    no_label: "10",
    kelompok: "C",
    kriteria:
      "Petugas pengangkut limbah menggunakan APD lengkap (sarung tangan kerja berat/utility gloves, sepatu boot, apron).",
    dasar_regulasi: "Permenkes 7/2019 (Kesling RS); Permenkes 27/2017 (APD)"
  },
  {
    no: 11,
    no_label: "11",
    kelompok: "C",
    kriteria:
      "Limbah tajam diangkut menggunakan troli khusus limbah B3/Infeksius yang tertutup.",
    dasar_regulasi:
      "Permenkes 7/2019 (Kesling RS); Permen LHK P.56/2015 (Limbah B3 Fasyankes)"
  },
  {
    no: 12,
    no_label: "12",
    kelompok: "C",
    kriteria:
      "Limbah tajam disimpan sementara di TPS B3 yang terdaftar dan terkunci dengan aman.",
    dasar_regulasi: "Permen LHK P.56/2015 (Limbah B3 Fasyankes); PP 22/2021"
  }
];

export const ALT_ITEM_COUNT = KRITERIA_AUDIT_LIMBAH_TAJAM.length;

export const AMBANG_SANGAT_BAIK = 85;
export const AMBANG_BAIK = 76;

export const KATEGORI_AUDIT_LIMBAH_TAJAM: Record<
  KategoriAuditLimbahTajam,
  { label: string; color: string }
> = {
  sangat_baik: { label: "SANGAT BAIK", color: "success" },
  baik: { label: "BAIK", color: "warning" },
  cukup_kurang: { label: "CUKUP/KURANG", color: "error" }
};

export function kategoriAuditLimbahTajam(
  rate: number | null
): KategoriAuditLimbahTajam | null {
  if (rate === null) return null;
  if (rate >= AMBANG_SANGAT_BAIK) return "sangat_baik";
  if (rate >= AMBANG_BAIK) return "baik";
  return "cukup_kurang";
}

export const METODE_AUDIT_OPTIONS = [
  { text: "Observasi Langsung", value: "observasi_langsung" },
  { text: "Wawancara", value: "wawancara" },
  { text: "Telusur Dokumen", value: "telusur_dokumen" }
];

export const PENILAIAN_OPTIONS: {
  text: string;
  value: PenilaianAuditLimbahTajam;
  color: string;
  icon: string;
}[] = [
  { text: "Ya", value: "ya", color: "success", icon: "mdi-check" },
  { text: "Tidak", value: "tidak", color: "error", icon: "mdi-close" },
  { text: "N/A", value: "na", color: "blue-grey", icon: "mdi-minus" }
];
